import { AnalyticsProvider } from '@/core/analytics/AnalyticsProvider.ts'
import { AnalyticsEvent } from './events/AnalyticsEvent.ts'

// No-op analytics for non-production hosts (production uses Mixpanel).
class DevAnalyticsProvider implements AnalyticsProvider {
  init(_token: string): void {}

  identify(_userId: string): void {}

  setUserProperties(_properties: Record<string, unknown>): void {}

  track(_event: AnalyticsEvent): void {}
}

export { DevAnalyticsProvider }
